// extracted by mini-css-extract-plugin
export default {"folder":"Folder_folder__f0LFo"};